import { Route } from "react-router-dom";
import { publicPath } from "@/utils/base";

// 引入页面
import NotFound from "@/pages/not-found";
import Portal from "@/pages/portal";

// 引入路由文件
import AccountRoutes from "./account";
import Home from "./home";

// type
import { RouteItemType } from "@/types/routes";

/**
 * 创建路由
 * @param routes 路由集合
 * @returns routes
 */
const renderRoutes = (routes: RouteItemType[]) => {
  return routes.map((item: RouteItemType, key: number) => {
    if (item && item.children) {
      return (
        <Route path={item.path} index={item.index} element={item.component} key={key}>
          {renderRoutes(item.children)}
        </Route>
      );
    } else {
      return <Route path={item.path} index={item.index} element={item.component} key={key}></Route>;
    }
  });
};

// 路由对象
const rootRoutes: RouteItemType[] = [
  {
    name: "",
    path: publicPath,
    component: <Portal />,
    children: [
      {
        name: "NotFound",
        path: "403",
        component: <NotFound />,
      },
      {
        name: "NotFound",
        path: "*",
        component: <NotFound />,
      },
      ...AccountRoutes,
      ...Home,
    ],
  },
];

export { rootRoutes, renderRoutes };
